import { render } from "./SpddList.vue?vue&type=template&id=3609b699"
import script from "./SpddList.vue?vue&type=script&lang=js"
export * from "./SpddList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__